var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container orgManage" },
    [
      _c(
        "div",
        { staticClass: "common-header" },
        [
          _c("common-header", {
            attrs: {
              headerList: [
                { label: "系统管理", url: "" },
                { label: "机构管理", url: "" }
              ]
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "role-top" },
        [
          _c("search-form", {
            attrs: { formData: _vm.searchFormData, btnType: _vm.btnType },
            on: {
              searchForm: _vm.searchForm,
              addTable: _vm.addTable,
              resetForm: _vm.resetForm
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "role-mid" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "role-content-tree" },
          [
            _vm.dataTree && _vm.dataTree.length > 0
              ? _c("el-tree", {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  ref: "tree",
                  staticStyle: { height: "100%" },
                  attrs: {
                    "node-key": "orgId",
                    props: _vm.defaultProps,
                    "default-expanded-keys": _vm.operateList,
                    load: _vm.loadNode,
                    "highlight-current": true,
                    "check-strictly": true,
                    "expand-on-click-node": false,
                    lazy: "",
                    "show-checkbox": ""
                  },
                  on: {
                    check: _vm.handleCheckChange,
                    "node-collapse": _vm.closeOperate
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var node = ref.node
                          var data = ref.data
                          return _c(
                            "div",
                            { staticClass: "custom-tree-node" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: node.label,
                                    placement: "top"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsisspan",
                                      staticStyle: {
                                        "line-height": "20px",
                                        display: "inline-block",
                                        "margin-left": "20px",
                                        "margin-right": "20px",
                                        width: "214px",
                                        "padding-left": "10px"
                                      }
                                    },
                                    [_vm._v(_vm._s(node.label))]
                                  )
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: data.orgId,
                                    placement: "top"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsisspan",
                                      staticStyle: {
                                        "line-height": "20px",
                                        width: "234px"
                                      }
                                    },
                                    [_vm._v(_vm._s(data.orgId))]
                                  )
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: data.pathName,
                                    placement: "top"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsisspan",
                                      staticStyle: {
                                        "line-height": "20px",
                                        width: "500px"
                                      }
                                    },
                                    [_vm._v(_vm._s(data.pathName))]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "custom-tree-node-right" },
                                [
                                  _c("div", { staticClass: "orgStatus" }, [
                                    _c("span", {
                                      class:
                                        node.data.orgStatus &&
                                        node.data.orgStatus == "VALID"
                                          ? "statusicon"
                                          : "unstatusicon"
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "statustitle" }, [
                                      _vm._v(
                                        _vm._s(
                                          node.data.orgStatus == null
                                            ? "失效"
                                            : node.data.orgStatus == "VALID"
                                            ? "有效"
                                            : "失效"
                                        )
                                      )
                                    ])
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-tree-node-right-operate"
                                    },
                                    [
                                      _c(
                                        "el-popover",
                                        {
                                          ref: data.orgId,
                                          attrs: {
                                            placement: "right",
                                            width: "200",
                                            trigger: "click",
                                            "popper-class": "table-popper"
                                          },
                                          on: {
                                            show: function($event) {
                                              return _vm.showPopover(data.orgId)
                                            },
                                            hide: function($event) {
                                              return _vm.popverClick(data.orgId)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "op-tips" },
                                            [
                                              data.direction == "UP" ||
                                              data.direction == "UP_AND_DOWN"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "op-item",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.sortResource(
                                                            data,
                                                            "up"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-caret-top",
                                                        staticStyle: {
                                                          "margin-left": "2px",
                                                          "margin-right":
                                                            "10px",
                                                          "margin-top": "3px"
                                                        }
                                                      }),
                                                      _c("span", [
                                                        _vm._v("排序增")
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              data.direction == "DOWN" ||
                                              data.direction == "UP_AND_DOWN"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "op-item",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.sortResource(
                                                            data,
                                                            "down"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-caret-bottom",
                                                        staticStyle: {
                                                          "margin-left": "2px",
                                                          "margin-right":
                                                            "10px",
                                                          "margin-bottom": "3px"
                                                        }
                                                      }),
                                                      _c("span", [
                                                        _vm._v("排序减")
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "op-item",
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.editRoleDialog(
                                                        node,
                                                        data
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("operate-edit-icon", {
                                                    staticClass:
                                                      "svgOperateIcon"
                                                  }),
                                                  _vm._v(" 编辑")
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-popover",
                                                {
                                                  ref: "" + (data.orgId + 1),
                                                  attrs: { trigger: "click" }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "delete-popover-container"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "delete-popover-content"
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-popconfirm__icon el-icon-question"
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "delTitle"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "确定删除此机构吗？"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "delete-popover-buttons"
                                                        },
                                                        [
                                                          _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                size: "mini"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.confirmdelmanage(
                                                                    node,
                                                                    data,
                                                                    false
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("取消")]
                                                          ),
                                                          _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                size: "mini",
                                                                type: "primary"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.confirmdelmanage(
                                                                    node,
                                                                    data,
                                                                    true
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("确定")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "op-item",
                                                      attrs: {
                                                        slot: "reference"
                                                      },
                                                      slot: "reference"
                                                    },
                                                    [
                                                      _c("delIcon", {
                                                        staticClass:
                                                          "svgOperateIcon"
                                                      }),
                                                      _vm._v(" 删除")
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              node.data.orgStatus == "VALID"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "op-item",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.addChildrenOrg(
                                                            node,
                                                            data
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("operateAddIcon", {
                                                        staticClass:
                                                          "svgOperateIcon"
                                                      }),
                                                      _vm._v(" 新增子机构")
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _c("operate", {
                                            staticClass: "operate-icon",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    4261702783
                  )
                })
              : _c(
                  "div",
                  {
                    staticStyle: {
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c("no-data", {
                      attrs: { height: "400px", width: "400px" }
                    })
                  ],
                  1
                )
          ],
          1
        )
      ]),
      _vm.showRoleRelate
        ? _c(
            "div",
            [
              _c(
                "el-dialog",
                {
                  directives: [
                    { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                  ],
                  staticClass: "org-dialog-wrapper",
                  attrs: {
                    title: _vm.isEdit
                      ? "编辑组织机构"
                      : _vm.childOrg
                      ? "新增子机构"
                      : "新增机构",
                    visible: _vm.showRoleRelate,
                    width: "560px"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.showRoleRelate = $event
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "dialog-body" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "ruleForm",
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "flex-wrap": "wrap"
                          },
                          attrs: {
                            "label-position": "top",
                            model: _vm.orgForm,
                            rules: _vm.orgRules,
                            "label-width": "120px"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "224px" },
                              attrs: { label: "组织机构编号", prop: "orgId" }
                            },
                            [
                              _c("el-input", {
                                staticClass: "limit32",
                                attrs: {
                                  maxlength: "32",
                                  "show-word-limit": "",
                                  placeholder: "请输入组织机构编号",
                                  disabled: _vm.isEdit,
                                  size: "small"
                                },
                                model: {
                                  value: _vm.orgForm.orgId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.orgForm,
                                      "orgId",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "orgForm.orgId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "224px" },
                              attrs: { label: "组织机构名称", prop: "orgName" }
                            },
                            [
                              _c("el-input", {
                                staticClass: "limit32",
                                attrs: {
                                  maxlength: "32",
                                  "show-word-limit": "",
                                  placeholder: "请输入组织机构名称",
                                  size: "small"
                                },
                                on: { change: _vm.getOrgNameSub },
                                model: {
                                  value: _vm.orgForm.orgName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.orgForm,
                                      "orgName",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "orgForm.orgName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "224px" },
                              attrs: { label: "组织机构类型", prop: "type" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择组织机构分类",
                                    size: "small",
                                    "collapse-tags": ""
                                  },
                                  model: {
                                    value: _vm.orgForm.type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.orgForm, "type", $$v)
                                    },
                                    expression: "orgForm.type"
                                  }
                                },
                                _vm._l(_vm.orgTypeList, function(item) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: {
                                      label: item.value,
                                      value: item.key
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "224px" },
                              attrs: { label: "组织机构标签", prop: "orgLabel" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    multiple: "",
                                    placeholder: "请选择组织机构分类",
                                    size: "small",
                                    "collapse-tags": ""
                                  },
                                  model: {
                                    value: _vm.orgForm.orgLabelCodeList,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.orgForm,
                                        "orgLabelCodeList",
                                        $$v
                                      )
                                    },
                                    expression: "orgForm.orgLabelCodeList"
                                  }
                                },
                                _vm._l(_vm.orgLabelList, function(item) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: {
                                      label: item.value,
                                      value: item.key
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm.isEdit
                            ? _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "224px" },
                                  attrs: { label: "机构状态", prop: "status" }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请输入内容",
                                        size: "small",
                                        "collapse-tags": ""
                                      },
                                      model: {
                                        value: _vm.orgForm.orgStatus,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.orgForm,
                                            "orgStatus",
                                            $$v
                                          )
                                        },
                                        expression: "orgForm.orgStatus"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        key: "INVALID",
                                        attrs: {
                                          label: "失效",
                                          value: "INVALID"
                                        }
                                      }),
                                      _c("el-option", {
                                        key: "VALID",
                                        attrs: { label: "有效", value: "VALID" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "dialog-footer" },
                    [
                      _c("el-button", { on: { click: _vm.dialogCancel } }, [
                        _vm._v("取消")
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addEditOrg }
                        },
                        [_vm._v("确认")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "footer-page" }, [
        _c("div", { staticClass: "role-footer-left" }, [
          _c("input", {
            staticClass: "btn btn-del",
            attrs: { type: "button", value: "删除" },
            on: { click: _vm.delOrgBtn }
          })
        ]),
        _c(
          "div",
          { staticClass: "role-footer-right" },
          [
            _vm.pageshow
              ? _c("el-pagination", {
                  attrs: {
                    background: "",
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total,
                    "page-sizes": [10, 20, 50, 100, 1000, 2000],
                    "current-page": _vm.pageNum,
                    "hide-on-single-page": false
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.pageNum = $event
                    },
                    "update:current-page": function($event) {
                      _vm.pageNum = $event
                    },
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            width: "382px",
            title: "删除机构",
            visible: _vm.ifShowDelDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.ifShowDelDialog = $event
            }
          }
        },
        [
          _c("del-dialog", {
            attrs: {
              tips1: "确定要删除所选机构吗？",
              tips2: "删除机构后无法恢复，是否要删除机构？"
            },
            on: {
              cancle: function($event) {
                _vm.ifShowDelDialog = false
              },
              commit: function($event) {
                _vm.isEditDel ? _vm.editDel() : _vm.delRole()
              }
            }
          })
        ],
        1
      ),
      _c("div", { staticStyle: { width: "1px", height: "50px" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "role-content" }, [
      _c("div", { staticClass: "role-content-top" }, [
        _c("p", { staticClass: "role-content-top-name" }, [
          _vm._v("组织机构名称")
        ]),
        _c("p", { staticClass: "role-content-top-num" }, [
          _vm._v("组织机构编号")
        ]),
        _c("p", { staticClass: "role-content-top-num" }, [
          _vm._v("组织机构全路径")
        ]),
        _c("div", { staticClass: "role-content-top-right" }, [
          _c("p", { staticClass: "role-content-top-status" }, [
            _vm._v("组织机构状态")
          ]),
          _c("p", { staticClass: "role-content-top-operate" }, [_vm._v("操作")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }